import { User, OperationLog } from './types';

export const mockUsers: User[] = [
  {
    uid: 'U10001',
    avatar: 'https://public.readdy.ai/ai/img_res/2076ece717253d2a68915f2dc5d58e2c.jpg',
    username: '张三',
    phone: '13800138001',
    registerTime: '2024-01-15 10:30:25',
    lastLoginTime: '2024-03-20 14:22:10',
    isVerified: true,
    status: 'normal',
    balance: 1580.50,
    points: 3200,
    tenants: ['山东科技大学', '青岛校区'],
    remark: 'VIP用户',
    registerMethod: 'campus',
    userType: ['学生'],
    wechat: 'zhangsan_wx',
    qq: '123456789',
    personalInfo: {
      name: '张三',
      idType: '居民身份证',
      idNumber: '370102199801011234',
      verifyTime: '2024-01-16 09:15:30',
    },
    campusInfo: {
      studentId: '2020010101',
      orgCode: 'ORG001',
      orgName: '山东科技大学',
      email: 'zhangsan@sdust.edu.cn',
      grade: '2020级',
      classCode: 'CS2020-01',
      className: '计算机科学与技术2020-1班',
      majorCode: 'CS001',
      majorName: '计算机科学与技术',
      enrollmentStatus: '在读',
      schoolSystem: '四年制',
      enrollmentTime: '2020-09-01',
    },
  },
  {
    uid: 'U10002',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20young%20asian%20female%20portrait%20with%20clean%20background%20in%20modern%20business%20casual%20style%20with%20natural%20lighting%20and%20friendly%20expression&width=100&height=100&seq=user-avatar-002&orientation=squarish',
    username: '李四',
    phone: '13900139002',
    registerTime: '2024-02-10 15:45:12',
    lastLoginTime: '2024-03-21 09:30:45',
    isVerified: true,
    status: 'normal',
    balance: 2350.00,
    points: 5600,
    tenants: ['山东科技大学'],
    remark: '',
    registerMethod: 'phone',
    userType: ['教职工'],
    wechat: 'lisi_wx',
    personalInfo: {
      name: '李四',
      idType: '居民身份证',
      idNumber: '370203198505152345',
      verifyTime: '2024-02-11 10:20:15',
    },
    campusInfo: {
      studentId: 'T2015001',
      orgCode: 'ORG001',
      orgName: '山东科技大学',
      email: 'lisi@sdust.edu.cn',
      grade: '-',
      classCode: '-',
      className: '-',
      majorCode: '-',
      majorName: '-',
      enrollmentStatus: '-',
      schoolSystem: '-',
      enrollmentTime: '-',
      employeeStatus: '在职',
    },
  },
  {
    uid: 'U10003',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20young%20asian%20male%20portrait%20with%20clean%20background%20in%20modern%20business%20casual%20style%20with%20natural%20lighting%20and%20friendly%20expression&width=100&height=100&seq=user-avatar-003&orientation=squarish',
    username: '王五',
    phone: '13700137003',
    registerTime: '2024-03-05 08:20:33',
    lastLoginTime: '2024-03-21 16:45:20',
    isVerified: false,
    status: 'normal',
    balance: 520.00,
    points: 1200,
    tenants: [],
    remark: '新用户',
    registerMethod: 'wechat',
    userType: ['企业员工'],
    wechat: 'wangwu_wx',
    qq: '987654321',
    enterpriseInfo: {
      name: '青岛科技有限公司',
      creditCode: '91370200MA3D1234XY',
      joinTime: '2024-03-05 08:25:10',
    },
  },
  {
    uid: 'U10004',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20young%20asian%20female%20portrait%20with%20clean%20background%20in%20modern%20business%20casual%20style%20with%20natural%20lighting%20and%20friendly%20expression&width=100&height=100&seq=user-avatar-004&orientation=squarish',
    username: '赵六',
    phone: '13600136004',
    registerTime: '2024-01-20 11:15:40',
    lastLoginTime: '2024-03-19 13:10:25',
    isVerified: true,
    status: 'disabled',
    balance: 0.00,
    points: 0,
    tenants: ['山东科技大学'],
    remark: '违规用户',
    registerMethod: 'campus',
    userType: ['学生'],
    personalInfo: {
      name: '赵六',
      idType: '居民身份证',
      idNumber: '370105199912123456',
      verifyTime: '2024-01-21 14:30:20',
    },
    campusInfo: {
      studentId: '2021020202',
      orgCode: 'ORG001',
      orgName: '山东科技大学',
      email: 'zhaoliu@sdust.edu.cn',
      grade: '2021级',
      classCode: 'SE2021-02',
      className: '软件工程2021-2班',
      majorCode: 'SE001',
      majorName: '软件工程',
      enrollmentStatus: '在读',
      schoolSystem: '四年制',
      enrollmentTime: '2021-09-01',
    },
  },
  {
    uid: 'U10005',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20young%20asian%20male%20portrait%20with%20clean%20background%20in%20modern%20business%20casual%20style%20with%20natural%20lighting%20and%20friendly%20expression&width=100&height=100&seq=user-avatar-005&orientation=squarish',
    username: '孙七',
    phone: '13500135005',
    registerTime: '2024-02-28 16:50:15',
    lastLoginTime: '2024-03-21 10:20:30',
    isVerified: true,
    status: 'normal',
    balance: 3200.00,
    points: 8900,
    tenants: ['山东科技大学', '济南校区'],
    remark: '活跃用户',
    registerMethod: 'qq',
    userType: ['学生', 'VIP用户'],
    qq: '555666777',
    personalInfo: {
      name: '孙七',
      idType: '居民身份证',
      idNumber: '370112200001015678',
      verifyTime: '2024-02-29 09:40:25',
    },
    campusInfo: {
      studentId: '2022030303',
      orgCode: 'ORG001',
      orgName: '山东科技大学',
      email: 'sunqi@sdust.edu.cn',
      grade: '2022级',
      classCode: 'AI2022-01',
      className: '人工智能2022-1班',
      majorCode: 'AI001',
      majorName: '人工智能',
      enrollmentStatus: '在读',
      schoolSystem: '四年制',
      enrollmentTime: '2022-09-01',
    },
  },
];

export const mockOperationLogs: OperationLog[] = [
  {
    time: '2024-03-21 16:45:20',
    type: '登录',
    ip: '192.168.1.100',
    device: 'Windows 11 / Chrome 122',
    detail: '登录',
  },
  {
    time: '2024-03-21 16:50:35',
    type: '创建实例',
    ip: '192.168.1.100',
    device: 'Windows 11 / Chrome 122',
    detail: '创建「INS-20240321-001」',
  },
  {
    time: '2024-03-20 14:22:10',
    type: '登录',
    ip: '192.168.1.105',
    device: 'macOS 14 / Safari 17',
    detail: '登录',
  },
  {
    time: '2024-03-20 15:30:25',
    type: '充值',
    ip: '192.168.1.105',
    device: 'macOS 14 / Safari 17',
    detail: '充值「500 元」',
  },
  {
    time: '2024-03-19 09:15:40',
    type: '删除实例',
    ip: '192.168.1.100',
    device: 'Windows 11 / Chrome 122',
    detail: '删除「INS-20240315-002」',
  },
  {
    time: '2024-03-18 11:20:15',
    type: '登录',
    ip: '192.168.1.100',
    device: 'Windows 11 / Chrome 122',
    detail: '登录',
  },
  {
    time: '2024-03-17 13:45:30',
    type: '创建实例',
    ip: '192.168.1.100',
    device: 'Windows 11 / Chrome 122',
    detail: '创建「INS-20240317-003」',
  },
  {
    time: '2024-03-16 10:30:20',
    type: '充值',
    ip: '192.168.1.100',
    device: 'Windows 11 / Chrome 122',
    detail: '充值「1000 元」',
  },
];
